// extracted by mini-css-extract-plugin
module.exports = {"root":"TagArticles_root__1hizk","title":"TagArticles_title__h5gRB","list":"TagArticles_list__kR_eQ"};